import AbstractPopupable from './AbstractPopupable';
import {ControlledPopupableProps, ControlledPopupableState} from '../../@types/components/ControlledPopupable';
import {Renderable} from '../../@types/Renderable';

type CP = ControlledPopupableProps;
type CS = ControlledPopupableState;

export default abstract class ControlledPopupable<P extends CP = CP, S extends CS = any, SS = any> extends AbstractPopupable<P, S, SS> {
    protected abstract getDropdownItems(): any[];

    protected abstract renderDropdownToggleContent(): Renderable;

    protected abstract renderDropdownItemContent(item: any, index: number): Renderable;

    // eslint-disable-next-line
    protected isActiveDropdownItem(item: any, index: number): boolean {
        return false;
    }
}
